import { render, staticRenderFns } from "./Advance.vue?vue&type=template&id=6a8c5a8f"
import script from "./Advance.vue?vue&type=script&lang=js"
export * from "./Advance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports